module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-2-128.5619bee093730595.jpg"+" 128w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-2-128.5619bee093730595.jpg",width: 128,height: 86}],
        src: "https://static.sniffspot.com/packs/img/bp-2-128.5619bee093730595.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-2-128.5619bee093730595.jpg"},
        
        width: 128,
        height: 86
      }